export const VARS = {
  cta: {
    message: 'Join Catch',
  },
  subscription: {
    defaultInterval: 'year' as const,
    defaultIntervalCount: 1,
  },
};
